import React, { useState, useEffect } from 'react';
import {
  Box, Typography, Paper,
  TextField, Button,  CircularProgress, MenuItem, Stack,
  List, Divider
} from '@mui/material';
import Horizontal from "./Horizontal";
import DepositDialog from './DepositDialog';
import DepositRow from './DepositRow';



export default function DeviceControl({ deviceId, info, balance, setBalance, settings, setSettings }) {

  const [openDepositDialog, setOpenDepositDialog] = React.useState(false);

  const [tempSettings, setTempSettings] = useState(settings);

  useEffect(() => {
    setTempSettings(settings);
  }, [settings]);

  const [saving, setSaving] = useState(false);

  const handleSaveSettings = async () => {
    setSaving(true);
    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/user/device/${deviceId}/settings`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(tempSettings)
      });

      if (response.ok) {
        setSettings(tempSettings);
      }
    } finally {
      setSaving(false);
    }
  };

  const user = JSON.parse(localStorage.getItem('user')) || null;
  const isAdmin = user && user.isAdmin === true;

  return (
    <Box>
      <Paper sx={{ p: 4, mt: 3, borderRadius: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, color: '#333', letterSpacing: '-0.5px', mb: 2 }}>
          Πληροφορίες Συσκευής
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Ο κωδικός της συσκευής είναι <strong>#{info.sku}</strong> και το μοντέλο της ειναι <strong>{info.version}</strong> {info.hasGps == true ? 'με GPS' : 'χωρίς GPS'}.<br></br>
          Η συσκευή είναι αυτή τη στιγμή <strong>{info.isOnline ? 'ενεργή' : 'ανενεργή'}</strong> και συγχρονίστηκε τελευταία φορά στις <strong>{new Date(info.lastOnline).toLocaleDateString()}</strong>.<br></br>
        </Typography>
      </Paper>
      <Horizontal>
        <Paper sx={{ p: 4, mt: 3, borderRadius: 2 }}>
          <Box sx={{ mb: 4 }}>
            <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 1 }}>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  color: '#333',
                  letterSpacing: '-0.5px'
                }}
              >
                Ρυθμίσεις Συσκευής
              </Typography>
            </Stack>

            <Typography variant="body2" color="text.secondary">
              Διαχειριστείτε το όνομα, την εμφάνιση και το πρόγραμμα αποστολής δεδομένων.
            </Typography>

            <Divider sx={{ mt: 2, borderBottomWidth: 2, borderColor: '#f0f0f0' }} />
          </Box>


          <Box sx={{ mb: 3 }}>
            <TextField
              label="Όνομα Συσκευής"
              value={tempSettings.name || ''}
              onChange={(e) => setTempSettings({ ...tempSettings, name: e.target.value })}
            />
          </Box>

          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold', color: 'text.secondary' }}>
            Ώρες Αποστολής Δεδομένων
          </Typography>

          {['time1', 'time2', 'time3'].map((timeKey, index) => (
            <Box key={timeKey} sx={{ mb: 3 }}>
              <TextField
                select
                id={timeKey}
                label={`Αποστολή ${index + 1}`}
                value={tempSettings[timeKey] > -1 ? tempSettings[timeKey] : -1}
                onChange={(e) => setTempSettings({ ...tempSettings, [timeKey]: e.target.value })}
                sx={{
                  minWidth: '150px',
                }}
              >
                <MenuItem key={-1} value={-1}>
                  Δεν ορίστηκε
                </MenuItem>
                {Array.from({ length: 24 }).map((_, hour) => {
                  const formattedHour = hour < 10 ? `0${hour}:00` : `${hour}:00`;
                  return (
                    <MenuItem key={formattedHour} value={hour}>
                      {formattedHour}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Box>
          ))}

          <Divider sx={{ mb: 4, borderBottomWidth: 2, borderColor: '#f0f0f0' }} />

          <Box sx={{ display: 'flex', justifyContent: 'center'}}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={handleSaveSettings}
              disabled={saving}
              startIcon={saving && <CircularProgress size={20} color="inherit" />}
            >
              {saving ? 'ΑΠΟΘΗΚΕΥΣΗ...' : 'ΑΠΟΘΗΚΕΥΣΗ ΑΛΛΑΓΩΝ'}
            </Button>
          </Box>
        </Paper>
        <Paper sx={{ p: 4, mt: 3, borderRadius: 2 }}>
          <Typography variant="h5" sx={{ fontWeight: 700, color: '#333', mb: 2 }}>
            Υπόλοιπο
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: { xs: 'column', sm: 'row' } }}>
            <Typography variant="h2" sx={{ fontWeight: 700, color: '#333', mb: 4 }}>
              {balance.amount !== null ? `${Number(balance.amount).toFixed(2)} €` : '---'}
            </Typography>

            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={() => setOpenDepositDialog(true)}
              sx={{ mb: 4 }}
            >
              ΦΟΡΤΙΣΗ ΤΑΜΕΙΟΥ
            </Button>
          </Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1, color: 'text.secondary' }}>
            Ιστορικό Καταθέσεων
          </Typography>

          <Divider sx={{ mb: 1 }} />

          <List sx={{ width: '100%', bgcolor: 'background.paper', maxHeight: 340, overflowY: 'auto' }}>
            {balance.deposits && balance.deposits.length > 0 ? (
              balance.deposits.map((deposit, index) => (
                <DepositRow
                  key={deposit._id}
                  deposit={deposit}
                  devSku={info.sku}
                  isLast={index === balance.deposits.length - 1}
                  isAdmin={isAdmin}
                  onSuccess={setBalance}
                />
              ))
            ) : (
              <Typography variant="body2" sx={{ textAlign: 'center', py: 4, color: 'text.disabled' }}>
                Δεν υπάρχουν ακόμα καταθέσεις
              </Typography>
            )}
          </List>

          <DepositDialog
            open={openDepositDialog}
            onClose={() => setOpenDepositDialog(false)}
            onSuccess={setBalance}
            deviceId={deviceId}
          />
        </Paper>
      </Horizontal>
    </Box>
  );
}
